// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file travel/v1/travel.proto (package travel.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Status, Travel } from "./common_pb";
import { file_travel_v1_common } from "./common_pb";
import type { PageRequest, PageResponse } from "../../tsam/v1/page_pb";
import { file_tsam_v1_page } from "../../tsam/v1/page_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travel/v1/travel.proto.
 */
export const file_travel_v1_travel: GenFile = /*@__PURE__*/
  fileDesc("ChZ0cmF2ZWwvdjEvdHJhdmVsLnByb3RvEgl0cmF2ZWwudjEiHwoKR2V0UmVxdWVzdBIRCgl0cmF2ZWxfaWQYASABKAkiMAoLR2V0UmVzcG9uc2USIQoGdHJhdmVsGAEgASgLMhEudHJhdmVsLnYxLlRyYXZlbCKTAQoYVHJhdmVsU2VydmljZUxpc3RSZXF1ZXN0EicKBHBhZ2UYASABKAsyFC50c2FtLnYxLlBhZ2VSZXF1ZXN0SACIAQESOQoHZmlsdGVycxgCIAEoCzIjLnRyYXZlbC52MS5UcmF2ZWxTZXJ2aWNlTGlzdEZpbHRlcnNIAYgBAUIHCgVfcGFnZUIKCghfZmlsdGVycyJkChlUcmF2ZWxTZXJ2aWNlTGlzdFJlc3BvbnNlEiIKB3RyYXZlbHMYASADKAsyES50cmF2ZWwudjEuVHJhdmVsEiMKBHBhZ2UYAiABKAsyFS50c2FtLnYxLlBhZ2VSZXNwb25zZSKxAgoYVHJhdmVsU2VydmljZUxpc3RGaWx0ZXJzEi0KBGZyb20YASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESKwoCdG8YAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESEgoFcGxhY2UYAyABKAlIAogBARIjCghzdGF0dXNlcxgEIAMoDjIRLnRyYXZlbC52MS5TdGF0dXMSEQoEdXNlchgFIAEoCUgDiAEBEhYKCWFnZW5jeV9pZBgGIAEoBUgEiAEBEhYKCWNhaXNzZV9pZBgHIAEoBUgFiAEBQgcKBV9mcm9tQgUKA190b0IICgZfcGxhY2VCBwoFX3VzZXJCDAoKX2FnZW5jeV9pZEIMCgpfY2Fpc3NlX2lkMpwBCg1UcmF2ZWxTZXJ2aWNlEjYKA0dldBIVLnRyYXZlbC52MS5HZXRSZXF1ZXN0GhYudHJhdmVsLnYxLkdldFJlc3BvbnNlIgASUwoETGlzdBIjLnRyYXZlbC52MS5UcmF2ZWxTZXJ2aWNlTGlzdFJlcXVlc3QaJC50cmF2ZWwudjEuVHJhdmVsU2VydmljZUxpc3RSZXNwb25zZSIAYgZwcm90bzM", [file_google_protobuf_timestamp, file_travel_v1_common, file_tsam_v1_page]);

/**
 * @generated from message travel.v1.GetRequest
 */
export type GetRequest = Message<"travel.v1.GetRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;
};

/**
 * Describes the message travel.v1.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_travel, 0);

/**
 * @generated from message travel.v1.GetResponse
 */
export type GetResponse = Message<"travel.v1.GetResponse"> & {
  /**
   * @generated from field: travel.v1.Travel travel = 1;
   */
  travel?: Travel;
};

/**
 * Describes the message travel.v1.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_travel, 1);

/**
 * @generated from message travel.v1.TravelServiceListRequest
 */
export type TravelServiceListRequest = Message<"travel.v1.TravelServiceListRequest"> & {
  /**
   * @generated from field: optional tsam.v1.PageRequest page = 1;
   */
  page?: PageRequest;

  /**
   * @generated from field: optional travel.v1.TravelServiceListFilters filters = 2;
   */
  filters?: TravelServiceListFilters;
};

/**
 * Describes the message travel.v1.TravelServiceListRequest.
 * Use `create(TravelServiceListRequestSchema)` to create a new message.
 */
export const TravelServiceListRequestSchema: GenMessage<TravelServiceListRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_travel, 2);

/**
 * @generated from message travel.v1.TravelServiceListResponse
 */
export type TravelServiceListResponse = Message<"travel.v1.TravelServiceListResponse"> & {
  /**
   * @generated from field: repeated travel.v1.Travel travels = 1;
   */
  travels: Travel[];

  /**
   * @generated from field: tsam.v1.PageResponse page = 2;
   */
  page?: PageResponse;
};

/**
 * Describes the message travel.v1.TravelServiceListResponse.
 * Use `create(TravelServiceListResponseSchema)` to create a new message.
 */
export const TravelServiceListResponseSchema: GenMessage<TravelServiceListResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_travel, 3);

/**
 * @generated from message travel.v1.TravelServiceListFilters
 */
export type TravelServiceListFilters = Message<"travel.v1.TravelServiceListFilters"> & {
  /**
   * user filters
   *
   * @generated from field: optional google.protobuf.Timestamp from = 1;
   */
  from?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp to = 2;
   */
  to?: Timestamp;

  /**
   * @generated from field: optional string place = 3;
   */
  place?: string;

  /**
   * @generated from field: repeated travel.v1.Status statuses = 4;
   */
  statuses: Status[];

  /**
   * elevated filters
   *
   * @generated from field: optional string user = 5;
   */
  user?: string;

  /**
   * @generated from field: optional int32 agency_id = 6;
   */
  agencyId?: number;

  /**
   * @generated from field: optional int32 caisse_id = 7;
   */
  caisseId?: number;
};

/**
 * Describes the message travel.v1.TravelServiceListFilters.
 * Use `create(TravelServiceListFiltersSchema)` to create a new message.
 */
export const TravelServiceListFiltersSchema: GenMessage<TravelServiceListFilters> = /*@__PURE__*/
  messageDesc(file_travel_v1_travel, 4);

/**
 * @generated from service travel.v1.TravelService
 */
export const TravelService: GenService<{
  /**
   * @generated from rpc travel.v1.TravelService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.TravelService.List
   */
  list: {
    methodKind: "unary";
    input: typeof TravelServiceListRequestSchema;
    output: typeof TravelServiceListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travel_v1_travel, 0);

